<template>
  <div>
    <f7-list>
      <!-- TODO: replace this with the built-in search/filter bar in F7 -->
      <f7-list-input :label="$t('label.budgetFilter')"
                     ref="autocomplete" type="text" :placeholder="$t('label.all')" @input:clear="clearFilter"
                     @input:empty="clearFilter" clear-button
      />
    </f7-list>
    <f7-block-title>Show only:</f7-block-title>
    <f7-block>
      <f7-segmented strong>
        <f7-button :text="$t('label.showPending')"
                   :active="!showProcessed"
                   @click="showProcessed = false"
        />
        <f7-button :text="$t('label.showProcessed')"
                   :active="showProcessed"
                   @click="showProcessed = true"
        />
      </f7-segmented>
    </f7-block>
  </div>
</template>

<script>
  export default {
    name: 'request-filter',
    data () {
      return {
        showProcessed: false,
      }
    },
    methods: {
      clearFilter () {
        this.$emit('set-filter', undefined)
      },
    },
    watch: {
      showProcessed: {
        immediate: true,
        handler (newVal) {
          this.$emit('show-processed', newVal)
        },
      },
    },
    mounted () {
      const self = this
      const input = self.$refs.autocomplete.$el.children[0]
      this.$f7.autocomplete.create({
        inputEl: input,
        openIn: 'dropdown',
        valueProperty: 'potId',
        textProperty: 'name',
        updateInputValueOnSelect: false,
        source (query, render) {
          const results = []
          self.budgets.forEach(b => {
            if (b.name.toLowerCase().indexOf(query.toLowerCase()) >= 0) {
              results.push(b)
            }
          })
          render(results)
        },
        on: {
          change: function (value) {
            const budget = value[0]
            this.inputEl.value = budget.name
            self.$emit('set-filter', budget.potId)
          },
        },
      })
      this.$bus.on('init-filter', function (budgetId) {
        input.value = self.budgets.find(b => b.potId === budgetId).name
        self.$emit('set-filter', budgetId)
      })
    },
    props: {
      budgets: Array,
    },
  }
</script>

<style scoped>

</style>
